import { EMAIL } from '../../Validations'
import { string, addMethod } from 'yup'

//Override the yup email check with a stricter regex
addMethod(string, 'email', function emailCheck(errorMessage: string) {
    return this.test({
        name: 'email',
        message: errorMessage || 'Invalid email format',
        test: function (value) {
            if (!value) return true
            return EMAIL.test(value)
        },
    })
})
